import { FC } from "react";
import { Button, Stack, Typography } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { SxProps } from "@mui/system";
import { UseMenuHookOpenMenu } from "@/utils/hooks/useMenu.hook";

interface FilterTreeDisabledViewButtonProps {
  onClick: UseMenuHookOpenMenu;
  disabled?: boolean;
  sx?: SxProps;
  filtersCount?: number;
}

export const FilterTreeDisabledViewButton: FC<
  FilterTreeDisabledViewButtonProps
> = ({ filtersCount, sx, disabled, onClick }) => {
  return (
    <Stack
      direction="row"
      onClick={onClick}
      component={Button}
      disabled={disabled}
      sx={{ ...stackStyles, ...sx }}
    >
      <FilterAltOutlinedIcon fontSize="small" />
      <Typography
        variant="body2"
        sx={{ textDecoration: "underline", textUnderlineOffset: 4 }}
      >
        Filters{!!filtersCount && ` (${filtersCount})`}
      </Typography>
    </Stack>
  );
};

const stackStyles = {
  pr: 1,
  pl: 0.5,
  spacing: 0.5,
  borderRadius: 1,
  alignItems: "center",
  bgcolor: "primary.light",
  "&:hover": {
    bgcolor: "primary.light",
    opacity: 0.9,
  },
};
